



/////////////////////////////////////////////////////////////////////////
// SoundLibrary //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const SoundLibrary = {

	// properties
	_musicVolume: 0.75,
  _fxVolume: 1.0,
  _overallVolume: 1.0,
  _musicWasPlayed: false,
	_playingMusicLoopTag: null,
	_playingMusicEndTag: null,
	
	sounds: {},		// dictionary of sounds & music

	init: function(game) {

		this.game = game;

	},

	loadSounds: function(audioPath) {

		// use Phaser to load and store the actual sound data
		for (var tag in this.sounds) 
		{
			var soundInst = this.sounds[tag];
			if (soundInst.path !== '') 
			{
			  // TODO
        // We have to figure out how to just copy all assets like this into a folder in the bundle
				this.game.load.audio(tag, [
          require(`file?name=audio/[name].ogg!../../../${audioPath}/${soundInst.path}.ogg`),
          require(`file?name=audio/[name].mp3!../../../${audioPath}/${soundInst.path}.mp3`)
				]);
			}
		}

	},

	createSounds: function() {
		
		// Called after all sounds are loaded
		// use Phaser to load and store the actual sound data
		for (var tag in this.sounds) 
		{
			var soundInst = this.sounds[tag];
			if (soundInst.path !== '') 
			{
				soundInst.sound = this.game.add.audio(tag, soundInst.volume || 1.0, soundInst.loop);
			}		
		}


	},

	playSound: function(tag, $volume, loop) {			
		
		var soundInst = this.sounds[tag];
		var volume = this._overallVolume * this._fxVolume * ((typeof $volume !== 'undefined') ? $volume : (soundInst.volume || 1.0));
		if (!soundInst.sound)
			return;

		if (volume === undefined)
		{
			soundInst.sound.play();	
		}
		else
		{
			soundInst.sound.play('', 0, volume, loop);
		}

		return soundInst.sound;
	},

	playMusicLoop: function(musicLoopTag) {

		// stop end music if needed
		this.stopMusicEnd();

		var sound = this.sounds[musicLoopTag].sound;
		var maxVolume = this._overallVolume * this._musicVolume;

		// this only works sporadically?
    sound.stop();
    // only do this first time
    if (!this._musicWasPlayed) {
      sound.play('', 0, 0, true);
      sound.fadeTo(500, maxVolume);

      this._musicWasPlayed = true;
    }
    else {
      sound.play('', 0, maxVolume, true, true);
    }
		//console.log('playMusicLoop');
		this._playingMusicLoopTag = musicLoopTag;

	},

	fadeOutMusic: function() {

		if (!this._playingMusicLoopTag)
			return;

		var sound = this.sounds[this._playingMusicLoopTag].sound;
		sound.fadeOut(1000);		

	},

	playMusicEnd: function(musicEndTag) {

		this._playingMusicEndTag = musicEndTag;

		var musicEnd = this.sounds[musicEndTag].sound;
		var musicLoop = (this._playingMusicLoopTag) ? this.sounds[this._playingMusicLoopTag].sound : null;
		if (musicLoop && musicLoop.isPlaying)
		{
			musicLoop.onLoop.addOnce(function() {

				// we do this because trying to stop the sound in this callback fails in IE
				setTimeout(this._playMusicEnd.bind(this), 10);				

			}, this);
		}
		else
		{
			this._playMusicEnd();
		}
	},

	_playMusicEnd: function() {

		// doing all this to stop looping in IE
		var musicLoop = (this._playingMusicLoopTag) ? this.sounds[this._playingMusicLoopTag].sound : null;
		var musicEnd = this.sounds[this._playingMusicEndTag].sound;

		this._playingMusicLoopTag = null;

		if (musicLoop) {
			musicLoop.pause();
		}
		
		if (!musicEnd.isPlaying) {
			var maxVolume = this._musicVolume;
			musicEnd.play('', 0, maxVolume, false);	
		}

	},

	stopMusicEnd: function() {

		if (!this._playingMusicEndTag)
			return;

		// stop the ending music
		var musicEnd = this.sounds[this._playingMusicEndTag].sound;
		musicEnd.pause();

		// stop listening for loops
		var musicLoop = (this._playingMusicLoopTag) ? this.sounds[this._playingMusicLoopTag].sound : null;
    if (musicLoop) {
      musicLoop.onLoop.removeAll();
    }


		this._playingMusicEndTag = null;
		this._playingMusicLoopTag = null;

	},

	mute: function() {

	  this.game.sound.mute = true;

	  // Use the the 'onMute' signal in game.sound to change ui
	  //...
	},
	    
	unmute: function() {

	  this.game.sound.mute = false;

	  // Use the the 'onUnMute' signal in game.sound
	  //...
	}		

};

Object.defineProperty(SoundLibrary, 'musicVolume', {

  get: function() {
    return this._musicVolume;
  },

  set: function(value) {

  	if (value === this._musicVolume)
  		return;

  	this._musicVolume = value;

    if (this._playingMusicEndTag) {
      this.sounds[this._playingMusicEndTag].sound.volume = value;
    }
    if (this._playingMusicLoopTag) {
      this.sounds[this._playingMusicLoopTag].sound.volume = value;
    }

  }
 
});

Object.defineProperty(SoundLibrary, 'fxVolume', {

  get: function() {
    return this._fxVolume;
  },

  set: function(value) {

    if (value === this._fxVolume)
      return;

    this._fxVolume = value;


  }

});

Object.defineProperty(SoundLibrary, 'overallVolume', {

  get: function() {
    return this.game.sound.volume;
  },

  set: function(value) {

  	if (value === this._overallVolume)
  		return;

  	this._overallVolume = value;

  	// mute?
  	if (value === 0) {
  		this.mute();
  	}
  	else if (this.game.sound.mute) {
  		this.unmute();
  	}

  	// use phaser sound manager
  	this.game.sound.volume = value;

  }
 
});

export default SoundLibrary;








// WEBPACK FOOTER //
// ./app/src/utils/sound/SoundLibrary.js